import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {toFixedFeatureCost, toFixedPrice} from "../../../../misc/helpers";
import {featureInterface} from "../../../../interfaces/featureInterface";


const ShopFeaturePrice = (props) => {

  const {feature, quantity, fabricatorSettings} = props;

  if (!feature) {
    return null;
  }

  const featurePrice = +toFixedFeatureCost(feature, Number.isInteger(quantity) ? quantity : 1);

  const finalPrice = toFixedPrice(featurePrice);
  const priceSplitted = (finalPrice + "").split(".");

  return (
    <div className="shop-feature__price">
      <span className="shop-feature__price-currency">{fabricatorSettings.currencySign}</span>
      <span className="shop-feature__price-amount">{priceSplitted[0]}</span>
      <span className="shop-feature__price-decimals">{priceSplitted[1]}</span>
    </div>
  )

};

ShopFeaturePrice.propTypes = {
  feature: PropTypes.shape(featureInterface)
}

const mapStateToProps = (store) => {
  const {settings} = store.fabricatorState;

  return {
    fabricatorSettings: settings,
  };
};

export default connect(mapStateToProps)(ShopFeaturePrice)
